export default __webpack_public_path__ + "static/media/Icon-calendar.7dcd7ab7.svg";